import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {deleteItem} from "../../../app/setters/deleteItem.js";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";

export const useUsunFile = (url) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: ({id}) => deleteItem(`${url}/${id}`),
        onError: () => toast.error('Błąd podczas operacji'),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`uploaded_files__/${MAIN_REJESTR_API_SHORT}/pliki/`)
            });
        },
        onSuccess: ({message, status}) => {
            dispatch(setSilent(true));
            status === 'success' ? toast.success(message) : toast.error(message);
        },
    });
};
